module.exports = __webpack_public_path__ + "static/media/17UN-Women5.063dba6c.jpg";